import { __exportAll } from "../_virtual/_rolldown/runtime.mjs";

// src/utils/constants.ts
var constants_exports = /* @__PURE__ */ __exportAll({
	CLASS_REMINDER_SMS_CUSTOMERIO_EVENT: () => CLASS_REMINDER_SMS_CUSTOMERIO_EVENT,
	NOTIFICATIONS_ASYNC_QUEUE_CHANNEL: () => NOTIFICATIONS_ASYNC_QUEUE_CHANNEL,
	SIGNUP_WELCOME_EMAIL_CHANNEL: () => SIGNUP_WELCOME_EMAIL_CHANNEL,
	SIGNUP_WELCOME_EMAIL_TYPE: () => SIGNUP_WELCOME_EMAIL_TYPE,
	STAFF_INACTIVITY_MS: () => STAFF_INACTIVITY_MS,
	STAFF_SESSIONS_COLLECTION: () => STAFF_SESSIONS_COLLECTION,
	STAFF_SESSION_FIELD_LAST_ACTIVITY: () => STAFF_SESSION_FIELD_LAST_ACTIVITY,
	STAFF_SESSION_FIELD_SESSION: () => STAFF_SESSION_FIELD_SESSION,
	STAFF_SESSION_HEARTBEAT_MS: () => STAFF_SESSION_HEARTBEAT_MS,
	STAFF_SESSION_ID_CLAIM: () => STAFF_SESSION_ID_CLAIM,
	STAFF_SESSION_LAST_ACTIVITY_MAX_FUTURE_MS: () => STAFF_SESSION_LAST_ACTIVITY_MAX_FUTURE_MS,
	TELLESCOPE_LONG_TIME_AGO_END_DAYS: () => 1,
	TELLESCOPE_LONG_TIME_AGO_START_DAYS: () => 7,
	TELLESCOPE_MAX_RETRIES_COUNT: () => 10
});
const SIGNUP_WELCOME_EMAIL_TYPE = "send_welcome_email";
const SIGNUP_WELCOME_EMAIL_CHANNEL = "signup-welcome-email-channel";
/** Shared Eventarc channel for notifications async work (webhooks, consult notify, welcome SMS). */
const NOTIFICATIONS_ASYNC_QUEUE_CHANNEL = "notifications-async-queue";
/** Customer.io `track` event name for class reminder SMS (journeys listen on this). */
const CLASS_REMINDER_SMS_CUSTOMERIO_EVENT = "class_reminder_sms";
const TELLESCOPE_MAX_RETRIES_COUNT = 10;
const TELLESCOPE_LONG_TIME_AGO_START_DAYS = 7;
const TELLESCOPE_LONG_TIME_AGO_END_DAYS = 1;
/**
* Staff session contract for Cloud Functions, Firestore (keep aligned with rules),
* and the frontend. This module has no backend-only dependencies.
*
* Firestore rules cannot import this file. When changing these values, update
* `firestore/firestore.rules` at the same time.
*/
const STAFF_SESSIONS_COLLECTION = "staffSessions";
/**
* Session claim set by Identity Platform `beforeUserSignedIn` (sessionClaims).
* Must match `staffSessions/{uid}.currentSession`.
*/
const STAFF_SESSION_ID_CLAIM = "ghStaffSid";
const STAFF_SESSION_FIELD_SESSION = "currentSession";
const STAFF_SESSION_FIELD_LAST_ACTIVITY = "lastActivityAt";
/**
* Server-enforced inactivity window (ms). Same duration as
* `firestore/firestore.rules` `duration.value(1, 'h')` for staff session checks.
*/
const STAFF_INACTIVITY_MS = 36e5;
/**
* Throttle for admin client `lastActivityAt` updates (ms) after real user activity.
* With a 1h inactivity window, 10m is enough margin to keep the session fresh.
*/
const STAFF_SESSION_HEARTBEAT_MS = 6e5;
/**
* `lastActivityAt` must not be more than this far in the future vs server time
* (align with `request.resource.data.lastActivityAt <= request.time + duration.value(5, 's')` in
* `firestore/firestore.rules` for `staffSessions` updates; rules cannot import this).
*/
const STAFF_SESSION_LAST_ACTIVITY_MAX_FUTURE_MS = 5e3;

export { CLASS_REMINDER_SMS_CUSTOMERIO_EVENT, NOTIFICATIONS_ASYNC_QUEUE_CHANNEL, SIGNUP_WELCOME_EMAIL_CHANNEL, SIGNUP_WELCOME_EMAIL_TYPE, STAFF_INACTIVITY_MS, STAFF_SESSIONS_COLLECTION, STAFF_SESSION_FIELD_LAST_ACTIVITY, STAFF_SESSION_FIELD_SESSION, STAFF_SESSION_HEARTBEAT_MS, STAFF_SESSION_ID_CLAIM, STAFF_SESSION_LAST_ACTIVITY_MAX_FUTURE_MS, TELLESCOPE_LONG_TIME_AGO_END_DAYS, TELLESCOPE_LONG_TIME_AGO_START_DAYS, TELLESCOPE_MAX_RETRIES_COUNT, constants_exports };
//# sourceMappingURL=constants.mjs.map